import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { AppClientComponentModule, ApplicationClientCommonModule, CommonTranslationModule } from '@sdbn/common';
import { TransportDocumentItemComponent } from './component/transport-document-item/transport-document-item.component';
import { TransportDocumentsListComponent } from './component/transport-document-list/transport-documents-list.component';
import { TransportDocumentsComponent } from './component/transport-documents.component';
import { TransportPhotoButtonComponent } from './component/transport-photo-button/transport-photo-button.component';



@NgModule({
  declarations: [
    TransportDocumentsComponent,
    TransportDocumentItemComponent,
    TransportPhotoButtonComponent,
    TransportDocumentsListComponent

  ],
  imports: [
    CommonModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    AppClientComponentModule
  ],
  exports: [
    TransportDocumentsComponent,
    TransportPhotoButtonComponent,
    TransportDocumentsListComponent
  ]
})
export class TransportDocumentsModule { }
